import React from 'react';
import { FieldConfig } from '../../../playground/common/field-types';
import { renderRateScheduleField } from '../../../playground/endpoints/_shared';
import { ContributionListField } from '../_shared';
import {
  GENDER_OPTIONS, LifeMaxFormValues, RATE_MODE_OPTIONS,
} from './schema';

const CLIENTE = 'Datos del cliente';
const CAPITALES = 'Capitales';
const MODO = 'Modo y campos específicos';
const APORTES = 'Aportes y primas';

const isFixedRate = (v: LifeMaxFormValues) => v.rate_mode === 'fixed';
const isSteppedRate = (v: LifeMaxFormValues) => v.rate_mode === 'stepped';

export const LIFE_MAX_FIELDS: readonly FieldConfig<LifeMaxFormValues>[] = [
  {
    key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date', section: CLIENTE,
  },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS, section: CLIENTE,
  },
  {
    key: 'death_insured_capital',
    label: 'Capital muerte (UF)',
    kind: 'number',
    colClassName: 'col-md-6',
    section: CAPITALES,
  },
  {
    key: 'rate_mode',
    label: 'Modo de tasa',
    kind: 'select',
    options: RATE_MODE_OPTIONS,
    section: MODO,
  },
  {
    key: 'projection_rate',
    label: 'Tasa de proyección anual',
    kind: 'number',
    step: 0.0001,
    visibleWhen: isFixedRate,
    section: MODO,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
    section: MODO,
  },
  {
    key: 'agreed_premium',
    label: 'Prima única (UF)',
    kind: 'number',
    section: APORTES,
  },
  {
    key: 'contributions',
    label: 'Aportes',
    kind: 'custom',
    render: (form) => (
      <ContributionListField
        form={form}
        name="contributions"
        addLabel="+ Agregar aporte"
        emptyLabel="Sin aportes."
      />
    ),
    section: APORTES,
  },
];
